import React from 'react'
import TextButton from '../../../../../common/Buttons/TextButton'

const qualityDefinitionLabel = 'Definition_of_Tidal_Levels'
const qualityDefinitionLink = 'https://www.metocean-on-demand.com/fileshare/getfile.ashx?type=image&file_name=Definition_of_tidal_levels.png'

export default function TidalLevelAdditionalContent() {
  return (
    <TextButton label={qualityDefinitionLabel} link={qualityDefinitionLink} />
  )
}
